import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify/react/dist/iconify.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Compact confirm dialog. Text is plain Tailwind rather than MUI Typography —
// DialogTitle's <h2> and Typography pick up the theme's large type scale.
const DeleteConfirmModal = ({
    open,
    handleClose,
    handleConfirm,
    title = 'Delete Community',
    itemName = '',
    description = 'This action cannot be undone. All associated data will be permanently removed.',
    isLoading = false,
}) => {
    return (
        <Dialog
            open={open}
            onClose={isLoading ? undefined : handleClose}
            TransitionComponent={Transition}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 2, overflow: 'hidden', maxWidth: 400 } }}
        >
            {/* Header */}
            <DialogTitle
                component="div"
                sx={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    px: 2, py: 1.25, borderBottom: '1px solid', borderColor: 'divider',
                }}
            >
                <div className="tw-text-sm tw-font-semibold tw-text-gray-800">{title}</div>
                <IconButton aria-label="close" onClick={handleClose} disabled={isLoading} size="small" sx={{ color: 'text.secondary', p: 0.5 }}>
                    <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
            </DialogTitle>

            {/* Content */}
            <DialogContent sx={{ px: 2, py: 2, '&.MuiDialogContent-root': { pt: 2 } }}>
                <div className="tw-flex tw-items-start tw-gap-3">
                    <div className="tw-w-9 tw-h-9 tw-rounded-full tw-bg-red-50 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                        <Icon icon="solar:trash-bin-trash-bold" className="tw-text-red-500 tw-text-lg" />
                    </div>
                    <div className="tw-min-w-0 tw-flex-1">
                        <p className="tw-text-sm tw-font-medium tw-text-gray-800 tw-mb-0">
                            Are you sure you want to delete{itemName ? '' : ' this item'}?
                        </p>

                        {itemName && (
                            <div className="tw-mt-2 tw-px-2.5 tw-py-1.5 tw-rounded-md tw-bg-gray-50 tw-border tw-border-gray-200 tw-text-xs tw-font-semibold tw-text-gray-800 tw-truncate">
                                {itemName}
                            </div>
                        )}

                        <p className="tw-text-[11px] tw-text-gray-500 tw-mt-2 tw-mb-0">
                            {description}
                        </p>
                    </div>
                </div>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ px: 2, py: 1.25, borderTop: '1px solid', borderColor: 'divider', gap: 1 }}>
                <button
                    type="button"
                    onClick={handleClose}
                    disabled={isLoading}
                    className="tw-h-8 tw-inline-flex tw-items-center tw-gap-1 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 hover:tw-bg-gray-50 disabled:tw-opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={handleConfirm}
                    disabled={isLoading}
                    className="tw-h-8 tw-inline-flex tw-items-center tw-gap-1 tw-px-3 tw-rounded-md tw-text-xs tw-font-medium tw-text-white tw-bg-red-600 hover:tw-bg-red-700 disabled:tw-opacity-60"
                    style={{ marginLeft: 0 }}
                >
                    {isLoading ? (
                        <>
                            <span className="tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border-2 tw-border-white tw-border-t-transparent" />
                            Deleting…
                        </>
                    ) : (
                        <>
                            <Icon icon="solar:trash-bin-trash-bold" className="tw-text-sm" />
                            Delete
                        </>
                    )}
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmModal;
